import {
    SET_TASKS_INCOMPLETE_COUNT
} from 'redux/actions/types/tasks';

export function setTasksIncompleteCount(count) {
    return {
        type: SET_TASKS_INCOMPLETE_COUNT,
        payload: count
    };
}